<template>
  <cockpit-dialog
    ref="cockpitDialogRef"
    title="关联文档查看"
    width="calc(100vw - 120px)"
    height="calc(100vh - 100px)"
    top="70px"
    left="60px"
    cardType="horizontal"
    @close="closeDialog"
  >
    <iframe :src="fileSrc" frameborder="0" class="h-full w-full"></iframe>
  </cockpit-dialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  components: { CockpitDialog },
  props: {
    fileSrc: {
      type: String,
    },
    // 枚举值，IMG、PDF
    fileType: {
      type: String,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.cockpitDialogRef?.$el
      if (el) {
        document.body.appendChild(el)
      }
    })
  }
}
</script>

<style></style>
